import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import MasterDataManagement from '../MenserviceMasterDataManagement/MasterDataManagement'
import Footer from '../Footer/Main'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Master Data Management" />
                <MasterDataManagement />
                <Footer />
            </div>
        </>
    )
}

export default Main